/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import Switch from 'react-switch'
import { Col, FormGroup, Input, Row } from 'reactstrap'
import { Controller } from 'react-hook-form'

const ProductDescReview = ({ item }) => {
  const [description, setDescription] = useState({
    UPC: '',
    BrandName: '',
    ProductName: '',
    Manufacturer: '',
    ProductDesc: '',
    ExchangeSize: '',
    UoM: '',
    IsBroadband: true,
    DistbInCA: false,
    RetailPrice: 0.0,
    FederalNutrition: false,
    ReviewerDescription: '',
  })

  useEffect(() => {
    if (item) {
      const {
        UPC,
        BrandName,
        ProductName,
        Manufacturer,
        ProductDesc,
        ExchangeSize,
        UoM,
        IsBroadband,
        DistbInCA,
        RetailPrice,
        FederalNutrition,
        ReviewerDescription,
      } = item
      setDescription({
        UPC: UPC ?? '',
        BrandName: BrandName ?? '',
        ProductName: ProductName ?? '',
        Manufacturer: Manufacturer ?? '',
        ProductDesc: ProductDesc ?? '',
        ExchangeSize: ExchangeSize ?? '',
        UoM: UoM ?? '',
        IsBroadband: IsBroadband ?? '',
        DistbInCA: DistbInCA ?? false,
        RetailPrice: RetailPrice ?? 0.0,
        FederalNutrition: FederalNutrition ?? false,
        ReviewerDescription: ReviewerDescription ?? '',
      })
    }
  }, [item])

  return (
    <div>
      <Row>
        <Col xs={2}>
          <FormGroup>
            <strong>UPC</strong>
            <Controller
              as={Input}
              name="UPC"
              placeholder={description.UPC}
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <strong>Manufacturer</strong>
            <Input
              name="Manufacturer"
              value={description.Manufacturer}
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={3}>
          <FormGroup>
            <strong>Brand name</strong>
            <Input name="BrandName" value={description.BrandName} disabled />
          </FormGroup>
        </Col>
        <Col xs={3}>
          <FormGroup>
            <strong>Product Name</strong>
            <Input
              name="ProductName"
              value={description.ProductName}
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <strong>Distributed in California</strong>
            <br />
            <Switch
              name="DistbInCA"
              id="DistbInCA"
              checked={description.DistbInCA || false}
              disabled
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col xs={2}>
          <FormGroup>
            <strong>Suggested Retail Price Per Unit</strong>
            <Input
              name="RetailPrice"
              value={description.RetailPrice}
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <strong>APL Description</strong>
            <Input
              name="ReviewerDescription"
              value={description.ReviewerDescription}
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={3}>
          <FormGroup>
            <strong>Product Description</strong>
            <Input
              name="ProductDesc"
              value={description.ProductDesc}
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={1}>
          <FormGroup>
            <strong>Exchange Size</strong>
            <Input
              name="ExchangeSize"
              value={description.ExchangeSize}
              disabled
            />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <strong>UOM</strong>
            <Input name="UoM" value={description.UoM} disabled />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <strong>Federal Nutrition</strong>
            <br />
            <Switch
              name="FederalNutrition"
              id="FederalNutrition"
              checked={description.FederalNutrition || false}
              disabled
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  )
}

export default ProductDescReview
